import { Injectable } from '@angular/core';
import { HttpClient } from '../../shared/http-client';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

import { KairosViewModel } from '../models/kairosViewModel'
import { ListadoKairos } from '../models/listadoKairos'

@Injectable()
export class KairosService {

  constructor(private httpClient: HttpClient) { }

  guardar(kairos: KairosViewModel) {
        let postData = { nombre: kairos.nombre, tipo: kairos.tipo };
        return this.httpClient.postWithFile('/kairos/', postData, { file: kairos.archivo, name: 'archivo' });
  }

  listado(pagina: number, cantidadPorPagina: number): Observable<ListadoKairos> {
    // get users from api
    return this.httpClient.get(`/kairos/?pagina=${pagina}&cantidadPorPagina=${cantidadPorPagina}`)
      .map(response => {
        return response.json();
      });
  }

  eliminar(id: string) {
    return this.httpClient.delete(`/kairos/${id}`);
}
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/intranet/services/kairos.service.ts